import React, {useRef, useState} from 'react';

import styles from './ContactForm.module.css';
import {contactUrl} from '../../constants/data';
import axios from 'axios';
import ConfirmBlock from '../ConfirmBlock';

const ContactForm = () => {
  const firstNameInputRef = useRef();
  const lastNameInputRef = useRef();
  const emailInputRef = useRef();
  const phoneInputRef = useRef();
  const messageInputRef = useRef();

  const [isSubmit, setIsSubmit] = useState(false);

  const inputBlock = (name, label, ref, placeholder, type='text') => {
    return (
      <div className={styles.form_field}>
        <p>
          { label }
        </p>
        <label htmlFor={name}>
          <input
            type={type}
            id={name}
            name={name}
            ref={ref}
            placeholder={placeholder}/>
        </label>
      </div>
    );
  };

  const doSubmit = (e) => {
    e.preventDefault();

    const entries = [
      {
        id: 705779417,
        name: 'First Name',
        value: firstNameInputRef.current.value,
      },
      {
        id: 247899007,
        name: 'Last Name',
        value: lastNameInputRef.current.value,
      },
      {
        id: 1969980678,
        name: 'Email',
        value: emailInputRef.current.value,
      },
      {
        id: 442057950,
        name: 'Phone',
        value: phoneInputRef.current.value,
      },
      {
        id: 1326780405,
        name: 'Message',
        value: messageInputRef.current.value,
      },
    ];

    const formData = new FormData();

    entries.map((entry) => {
      formData.append(`entry.${entry.id}`, entry.value);
    });

    axios.post('https://shaking-cors-proxy.herokuapp.com/' + contactUrl.googleFormUrl, formData)
        .catch((e) => console.log(e))
        .finally(() => setIsSubmit(true));
  };

  return (
    <div className={styles.app__contact_form}>
      <div className={styles.app__contact_form_title}>Let&apos;s Talk</div>
      <div className={styles.app__contact_form_wrapper}>
        {isSubmit ?
            <ConfirmBlock /> :
            <form onSubmit={doSubmit}>
              <fieldset className={styles.contact_form}>
                <div className={styles.contact_form_name_wrapper}>
                  <span>
                    {inputBlock(
                        'firstName',
                        'First Name',
                        firstNameInputRef,
                        '')}
                  </span>
                  <span>
                    {inputBlock(
                        'lastName',
                        'Last Name',
                        lastNameInputRef,
                        '')}
                  </span>
                </div>
                <div>
                  {inputBlock(
                      'email',
                      'Email',
                      emailInputRef,
                      '',
                      'email')}
                </div>
                <div>
                  {inputBlock(
                      'phone',
                      'Phone number',
                      phoneInputRef,
                      '### - ### - ####')}
                </div>
                <div className={styles.form_field}>
                  <p>Message</p>
                  <label htmlFor="message">
                    <textarea
                      id="message"
                      name="message"
                      ref={messageInputRef}
                      placeholder={`Enter your message here`}/>
                  </label>
                </div>
                <p>
                  <button className="custom__purple-button">SUBMIT</button>
                </p>
              </fieldset>
            </form>}
        <div className={styles.ending}>

        </div>
      </div>
    </div>
  );
};

export default ContactForm;
